import React from "react";
import {Helmet} from "react-helmet";
import BackgroundSection from "../../components/BackgroundSection/BackgroundSection";
import SectionTeam from "./SectionTeam";
import BgGlassmorphism from "../../components/BgGlassmorphism/BgGlassmorphism";
import Sectionbanner from "./Sectionbanner";
import {DEMO_POSTS} from "../../data/posts";
import SectionHero from "components/SectionHero/SectionHero";

DEMO_POSTS.filter((_, i) => i >= 8 && i < 16);
DEMO_POSTS.filter((_, i) => i >= 0 && i < 7);
const POSTS = DEMO_POSTS;


const PageHome: React.FC = () => {
  return (
    <div className="PageHome relative">
      <Helmet>
        <title>CryptoVerse</title>
      </Helmet>
      <BgGlassmorphism/>
      <div className="relative overflow-hidden">
        <div className="container relative ">
          <div className="container">
            <div className="relative py-5 ">
              <BackgroundSection/>
              <Sectionbanner/>
            </div>
          </div>
        </div>
      </div>
      <div className="container relative">
        <SectionHero
          className="pt-10 pb-16 md:py-16 lg:py-28"
          btnText="Getting started"
          subHeading="The CryptoVerse offers the universe's latest Web3 community, delivering real-time data from real-world markets while catalysing community growth."
          heading={
          <span>
            Welcome To The <br /> CryptoVerse.{``}
            <span className="relative pr-3">
              <img className="w-full absolute top-1/2 -left-1 transform -translate-y-1/2" alt=""/>
            </span>
          </span>
        }
        />
      </div>
      <div className="relative overflow-hidden">
        <div className="container relative ">
          <SectionTeam className="relative"/>
          <div className="container py- "></div>
        </div>
      </div>
    </div>
  );
}

export default PageHome;
